import StarIcon from './star'
import StarActiveIcon from './star-active'
import StarBigIcon from './star-big'
import StarBigActiveIcon from './star-big-active'
import ClockIcon from './clock'
import UserIcon from './user'
import CheckIcon from './check'
import ArrowLeftIcon from './arrow-left'
import ArrowRightIcon from './arrow-right'
import PlusIcon from './plus'
import DoneIcon from './done'
import MoneyIcon from './money'

export default {
  StarIcon,
  StarActiveIcon,
  ClockIcon,
  UserIcon,
  CheckIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  PlusIcon,
  DoneIcon,
  StarBigIcon,
  StarBigActiveIcon,
  MoneyIcon
}